import { Feature } from "ol";
import GeoJSON from "ol/format/GeoJSON";
import VectorSource from "ol/source/Vector";
import { useContext, useEffect, useState } from "react";
import MapContext from "./MapContext";
import { VECTOR_LAYERS } from "./MapView";
import { Geometry } from "ol/geom";
import { FieldStyle } from "./MapStyles";

function MapFeature({ id, geometry }: { id?: string; geometry: Object }) {
  const { map } = useContext(MapContext);
  const [feature, setFeature] = useState<Feature<Geometry>>();
  useEffect(() => {
    const geojson = new GeoJSON();
    const geom = geometry && geojson.readGeometry(geometry);
    const feature = geom && new Feature(geom);
    feature?.getGeometry()?.transform("EPSG:4326", "EPSG:3857");
    const layer = map
      ?.getAllLayers()
      ?.find((l) => l.getProperties()?.name === VECTOR_LAYERS.FIELDS);
    const source = layer?.getSource() as VectorSource | undefined;
    feature && source?.addFeature(feature);
    feature && setFeature(feature);
    return () => {
      feature && source?.removeFeature(feature);
      setFeature(undefined);
    };
  }, [map, geometry, id]);
  useEffect(() => {
    feature?.setStyle(FieldStyle);
    return () => feature?.setStyle(undefined);
  }, [feature]);
  return null;
}

export default MapFeature;
